<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="160px">
            <el-form-item label="日期：" prop="day">
                <span>{{model.day}}</span>
            </el-form-item>
            <el-form-item label="需巡检设备数量：" prop="device_count">
                <span>{{model.device_count}}</span>
            </el-form-item>
            <el-form-item label="实际巡检数量：" prop="device_count_yes">
                <span>{{model.device_count_yes}}</span>
            </el-form-item>
            <el-form-item label="未巡检数量：" prop="device_count_no">
                <span>{{model.device_count_no}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceInspectionReportEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                top_pid: '',
                day: '',
                device_count: '',
                device_count_yes: '',
                device_count_no: '',
                add_time: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/deviceinspectionreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/deviceinspectionreport/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>